var _path, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9995 16.2941V10.563V7.70541C18.9995 6.21314 17.7859 5 16.2936 5H7.70541C6.21314 5 5 6.21314 5 7.70541V10.563V16.2941C5 17.7869 6.21314 19 7.70541 19H16.2941C17.7859 19 18.9995 17.7869 18.9995 16.2941ZM14.4642 11.9993C14.4642 13.3582 13.3572 14.4632 11.9993 14.4632C10.6409 14.4632 9.53479 13.3577 9.53628 11.9988C9.53678 11.4623 9.71079 10.9671 10.0023 10.5625C10.451 9.94182 11.1783 9.53529 12.0007 9.53529C12.8227 9.53529 13.5505 9.94231 13.9982 10.563C14.2887 10.9676 14.4642 11.4628 14.4642 11.9993ZM17.3798 8.98499V6.91961V6.61224L17.071 6.61323L15.0066 6.61967L15.0145 8.99292L17.3798 8.98499ZM11.9998 15.8281C14.1112 15.8281 15.8286 14.1097 15.8286 11.9993C15.8286 11.4916 15.7259 11.0062 15.544 10.563H17.6347V16.2941C17.6347 17.0348 17.0323 17.6347 16.2931 17.6347H7.70491C6.96473 17.6347 6.36336 17.0348 6.36336 16.2941V10.563H8.45303C8.27257 11.0062 8.17143 11.4916 8.17143 11.9993C8.17143 14.1097 9.88827 15.8281 11.9998 15.8281Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9995 16.2941V10.563V7.70541C18.9995 6.21314 17.7859 5 16.2936 5H7.70541C6.21314 5 5 6.21314 5 7.70541V10.563V16.2941C5 17.7869 6.21314 19 7.70541 19H16.2941C17.7859 19 18.9995 17.7869 18.9995 16.2941ZM14.4642 11.9993C14.4642 13.3582 13.3572 14.4632 11.9993 14.4632C10.6409 14.4632 9.53479 13.3577 9.53628 11.9988C9.53678 11.4623 9.71079 10.9671 10.0023 10.5625C10.451 9.94182 11.1783 9.53529 12.0007 9.53529C12.8227 9.53529 13.5505 9.94231 13.9982 10.563C14.2887 10.9676 14.4642 11.4628 14.4642 11.9993ZM17.3798 8.98499V6.91961V6.61224L17.071 6.61323L15.0066 6.61967L15.0145 8.99292L17.3798 8.98499ZM11.9998 15.8281C14.1112 15.8281 15.8286 14.1097 15.8286 11.9993C15.8286 11.4916 15.7259 11.0062 15.544 10.563H17.6347V16.2941C17.6347 17.0348 17.0323 17.6347 16.2931 17.6347H7.70491C6.96473 17.6347 6.36336 17.0348 6.36336 16.2941V10.563H8.45303C8.27257 11.0062 8.17143 11.4916 8.17143 11.9993C8.17143 14.1097 9.88827 15.8281 11.9998 15.8281Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5d20839f.svg";
export { ForwardRef as ReactComponent };